import { ChartSvg } from "@/components/tool-kit/charts/chart-svg";
import { Arrow, TextLines } from "@/components/tool-kit/diagrams/svg-parts";
import {
  DIAGRAM_HEIGHT,
  DIAGRAM_WIDTH,
  type DiagramLayout,
} from "@/lib/tool-kit/business-templates/five-forces-layout";
import { CHART_INK } from "@/lib/tool-kit/palette";

const TITLE_LINE = 17;
const NOTE_LINE = 14;
const PAD = 12;

/** The five-forces diagram as a self-contained SVG, drawn from `layoutDiagram`. */
export function FiveForcesDiagram({
  id,
  layout,
  title,
  footer,
  label,
  description,
}: {
  id: string;
  layout: DiagramLayout;
  title: string;
  footer: string;
  label: string;
  description: string;
}) {
  return (
    <ChartSvg
      description={description}
      height={DIAGRAM_HEIGHT}
      id={id}
      label={label}
      width={DIAGRAM_WIDTH}
    >
      <TextLines
        anchor="middle"
        bold
        fontSize={18}
        lineHeight={24}
        lines={[title]}
        top={14}
        x={DIAGRAM_WIDTH / 2}
      />
      {layout.arrows.map((points) => (
        <Arrow
          color={CHART_INK.muted}
          head={9}
          key={points.map((point) => point.join(",")).join(">")}
          points={points}
          width={2}
        />
      ))}
      {layout.boxes.map((box) => {
        const titleHeight = box.titleLines.length * TITLE_LINE;
        const centre = box.x + box.width / 2;
        return (
          <g key={box.force}>
            <rect
              fill={box.fill}
              height={box.height}
              rx={8}
              stroke={CHART_INK.axis}
              strokeWidth={1.5}
              width={box.width}
              x={box.x}
              y={box.y}
            />
            <TextLines
              anchor="middle"
              bold
              fontSize={14}
              lineHeight={TITLE_LINE}
              lines={box.titleLines}
              top={box.y + PAD}
              x={centre}
            />
            <TextLines
              anchor="middle"
              bold
              fill={CHART_INK.text}
              fontSize={12}
              lineHeight={16}
              lines={[box.ratingLine]}
              top={box.y + PAD + titleHeight + 4}
              x={centre}
            />
            <TextLines
              anchor="middle"
              fill={CHART_INK.text}
              fontSize={11}
              lineHeight={NOTE_LINE}
              lines={box.noteLines}
              top={box.y + PAD + titleHeight + 24}
              x={centre}
            />
          </g>
        );
      })}
      <TextLines
        anchor="middle"
        fill={CHART_INK.muted}
        fontSize={11}
        lineHeight={14}
        lines={[footer]}
        top={DIAGRAM_HEIGHT - 28}
        x={DIAGRAM_WIDTH / 2}
      />
    </ChartSvg>
  );
}
